import apiClient from './apiClient';

class EmailSettingService {
    // Current SMTP settings (password is never returned, only has_password)
    async getSettings() {
        try {
            const response = await apiClient.get('/settings/email');
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            console.error('Error fetching email settings:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to fetch email settings'
            };
        }
    }

    // Save SMTP settings. Omit `password` to keep the stored one.
    async updateSettings(settings) {
        try {
            const response = await apiClient.put('/settings/email', settings);
            return {
                success: true,
                data: response.data.data,
                message: response.data.message
            };
        } catch (error) {
            console.error('Error saving email settings:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to save email settings',
                errors: error.response?.data?.errors
            };
        }
    }

    // Send a test email using the stored settings
    async sendTestEmail(toEmail) {
        try {
            const response = await apiClient.post('/settings/email/test', { to_email: toEmail });
            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            console.error('Error sending test email:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to send test email'
            };
        }
    }
}

export const emailSettingService = new EmailSettingService();
export default emailSettingService;
